import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MailWarning } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './EmailVerificationBanner.css';

// Pages that already are the verification flow — no banner there.
const VERIFY_PATHS = ['/verification-pending', '/verify-email'];

/**
 * Persistent reminder for a signed-in user who hasn't verified their email.
 *
 * ProtectedRoute already bounces unverified users to /verification-pending,
 * but if they land on a public page (or the redirect ever fails open on an
 * undefined flag) this keeps the nudge visible. Clicking it takes them to the
 * code-entry page so they can finish verifying — which is also what triggers
 * the server-side team-invitation join.
 */
const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // `!user.email_verified` (truthy check, not `=== false`) so an undefined
  // flag is treated as unverified rather than silently hiding the banner.
  const shouldShow =
    user && !user.email_verified && !VERIFY_PATHS.includes(location.pathname);

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="email-verify-banner" role="status">
      <MailWarning className="email-verify-banner__icon" size={18} aria-hidden="true" />
      <span className="email-verify-banner__text">
        Please verify your email to secure your account and join your care team.
      </span>
      <button
        type="button"
        className="email-verify-banner__btn"
        onClick={() => navigate('/verification-pending')}
      >
        Verify now
      </button>
    </div>
  );
};

export default EmailVerificationBanner;
